$(window).load(function () {
    const OFFSET = 80;

    let sidebar = $('.bn_fixed-sidebar');

    if (sidebar.length) {
        let track = $('.bn_fixed-sidebar-track'),
            trackTop = sidebar.offset().top - OFFSET,
            trackBottom = track.offset().top + track.outerHeight(),
            positionTop = track.outerHeight() - sidebar.outerHeight(),
            sidebarTop = trackBottom - sidebar.outerHeight(),
            maxScroll = sidebarTop - OFFSET;

        track.css({'min-height': track.outerHeight()})

        $(window).scroll(function() {
            let scroll = $(this).scrollTop();

            if (scroll > trackTop) {
                if (scroll < maxScroll) {
                    sidebar.addClass('fixed').removeAttr('style');
                } else {
                    sidebar.removeClass('fixed').css({position: 'absolute', top: positionTop + 'px'});
                }
            } else {
                sidebar.removeClass('fixed');
            }
        });

        $(window).scroll();
    }
})